// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__OZWYk","message":"Loader_message__A0fVa"};